import React, { useRef, useEffect, useCallback, useState} from 'react';
import {getYoutubeThumbnail} from "utils/getYoutubeThumbnail.js"

import ethereum from "decentralized/ethereum.js";
import {getReleases} from "decentralized/artists/Artists.js";
import ipfs from "decentralized/Ipfs.js"
import Dropdown from 'react-dropdown';
import {SOUNDS_SEARCH, SELECTOR_LIST_VIEW, SELECTOR_GRID_VIEW} from 'constants/contextual-help.js';
import Documented from 'components/help/Documented.js';
import {connect} from 'react-redux';
import {GRID, LIST, TAG, DAY} from './constants.js';
import {setContextualHelp} from "actions/index.js";

const OPTIONS = [
    {value: DAY, label: 'Day'},
    {value: TAG, label: 'Tag'},
];
let id=0;
const SampleSearch = ({
    setContextualHelp,
    onChange,
    displayOption,
    setDisplayOption,
    quickAddSearchText,
    groupBy,
    setGroupBy,
    hideFilter,
    setFilterFavorites,
    filterFavorites,
    sourceToSearch,
    children
}) => { 
    let ref = useRef(undefined);
    let [value, setValue] = useState(quickAddSearchText);
    let [thumb, setThumb] = useState(undefined);

    useEffect(() => {
        window.addEventListener("keydown", onKeyDown);
        return () => window.removeEventListener("keydown", onKeyDown);
    }, []);

    const onKeyDown = useCallback((e) => {
        if (e.key === '/' && (e.ctrlKey || e.metaKey)) {
            // ref.current.focus();
        } else if (e.key === "ArrowDown" || e.key === "ArrowUp") {
            e.preventDefault();
            ref.current.blur();
        }
    }, []);

    useEffect(() => {
        ref.current.focus();
    }, []);

    useEffect(() => {
        if (sourceToSearch) {
            let {videoId, releaseId} = sourceToSearch;
            if (releaseId) {
                ethereum.getCoverArtForDiscogs(releaseId)
                    .then(({coverArtHash}) => setThumb(ipfs.getHashUrl(coverArtHash)));
            } else {
                setThumb(getYoutubeThumbnail(videoId));
            }
        }  else {
            setThumb(undefined);
        }
    }, [sourceToSearch, setThumb]);

    const _onChange = useCallback((e) => {
        let _id = ++id;
        let _value = e.target.value;
        setValue(_value);
        setTimeout(() => {
            if (_id === id) {
                onChange(_value);
            }
        }, 600);
    }, [setValue, onChange]);

    useEffect(() => {
        if (quickAddSearchText) {
            setValue(quickAddSearchText);
        }
    }, [quickAddSearchText, setValue]);

    return (
        <Documented element={SOUNDS_SEARCH} className="entire-search-container">
          {children}
          <div className="search-rest">
            <div className="search-container">
              <input 
                ref={ref}
            placeholder="Type to search"
            autoComplete="off"
            type="text"
            value={value}
            onKeyDown={onKeyDown}
            onChange={_onChange}
            id="sample-search-input"/>
            {thumb ? <img src={thumb} className="source-to-search"></img> : ''}
          <div onClick={() => _onChange({target: {value: ""}})} className="search-clear-button">x</div>
          {setDisplayOption !== undefined ? 
           <img
             onMouseOver={(e) => {
                 e.stopPropagation();
                 setContextualHelp(SELECTOR_GRID_VIEW);
             }}
             onMouseLeave={() => setContextualHelp(undefined)}
             onClick={() => setDisplayOption(GRID)}
             className={displayOption === GRID ? "selected" : ""} src="/grid-icon.png"/> : ''}
              {setDisplayOption !== undefined  ? 
           <img
             onMouseOver={(e) => {
                 e.stopPropagation();
                 setContextualHelp(SELECTOR_LIST_VIEW);
             }}
             onMouseLeave={() => setContextualHelp(undefined)}
             onClick={() => setDisplayOption(LIST)}
              className={displayOption === LIST ? "selected" : value === "" && !filterFavorites ? "disabled" : ""} src="/list-icon.png"/> : ''}
          </div>
          {!hideFilter ? 
           <div className="filter-options">
             <div
               className={filterFavorites ? "favorited heart" : "heart"}
               onClick={() => setFilterFavorites(!filterFavorites)}/>
             <Dropdown
               onChange={(o) => setGroupBy(o.value)}
               value={OPTIONS.find(x => x.value === groupBy)}
               options={OPTIONS}
             />
           </div> : ''}
          </div>
        </Documented>);
}

const mapStateToProps = (state, props) => {
  return {
      //quickAddSearchText: state.selector.quickAddSearchText
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
      setContextualHelp: (element, arg) => dispatch(setContextualHelp(element, arg)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SampleSearch);
